import React from 'react';
import { Tag } from 'antd';
import {
  SyncOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  ShoppingCartOutlined,
  CarOutlined,
  InboxOutlined,
} from '@ant-design/icons';
import { OrderStatusProp } from '@app/interfaces/order';
import './OrderStatus.css';

interface OrderStatusProps {
  status: OrderStatusProp;
}

interface StatusStyle {
  color: string;
  icon: React.ReactNode;
  /** Nhãn ngắn dùng trong bảng; mô tả đầy đủ nằm ở tooltip của Tag. */
  label: string;
}

/**
 * Bảng màu/icon theo `order_status_id` (bảng `order_statuses`).
 * Dùng màu preset của AntD (nền nhạt + chữ đậm) thay vì hex nền đặc: chữ dễ đọc
 * hơn và Tag không "chiếm sáng" cả hàng khi bảng có nhiều cột.
 */
const STATUS_STYLES: Record<number, StatusStyle> = {
  1: { color: 'blue', icon: <ShoppingCartOutlined />, label: 'Mới' },
  2: { color: 'orange', icon: <ExclamationCircleOutlined />, label: 'Chờ xác nhận' },
  3: { color: 'purple', icon: <SyncOutlined spin />, label: 'Đang xử lý' },
  4: { color: 'geekblue', icon: <CheckCircleOutlined />, label: 'Đã xác nhận' },
  5: { color: 'gold', icon: <InboxOutlined />, label: 'Chuyển giao' },
  6: { color: 'cyan', icon: <CarOutlined />, label: 'Đang giao' },
  7: { color: 'green', icon: <CheckCircleOutlined />, label: 'Hoàn thành' },
  8: { color: 'red', icon: <CloseCircleOutlined />, label: 'Huỷ' },
};

const FALLBACK: StatusStyle = { color: 'default', icon: <ShoppingCartOutlined />, label: '—' };

const OrderStatus: React.FC<OrderStatusProps> = ({ status }) => {
  const style = STATUS_STYLES[status?.id] ?? FALLBACK;
  const label = status?.description || style.label;

  return (
    <Tag color={style.color} icon={style.icon} className="order-status-tag" title={label}>
      {label}
    </Tag>
  );
};

export default OrderStatus;
